import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const SLICE_NAME = 'mcc';
const GET_CURRENCIES = SLICE_NAME + '/currencies';
const GET_MCC_RATES = SLICE_NAME + '/rates';
const UPDATE_MCC_RATES = SLICE_NAME + '/rates/update';

export const getMCCCurrencies = createAsyncThunk(
  GET_CURRENCIES,
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get(
        '/mcc/fetch/currency-details',
        payload,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getMCCRates = createAsyncThunk(
  GET_MCC_RATES,
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/mcc/fetch/mcc-rates', {
        params: payload,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateMCCRates = createAsyncThunk(
  UPDATE_MCC_RATES,
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/mcc/update/mcc-rates', null, {
        params: payload,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const mccSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    isFetchingMCCCurrencies: false,
    mccCurrencies: [],

    isFetchingMCCRates: false,
    mccRates: null,

    isUpdatingMCCRates: false,
  },
  reducers: {},
  extraReducers: {
    [getMCCCurrencies.pending]: (state) => {
      state.isFetchingMCCCurrencies = true;
      state.mccCurrencies = [];
    },
    [getMCCCurrencies.rejected]: (state) => {
      state.isFetchingMCCCurrencies = false;
      state.mccCurrencies = [];
    },
    [getMCCCurrencies.fulfilled]: (state, { payload }) => {
      state.isFetchingMCCCurrencies = false;
      state.mccCurrencies = payload.sort();
    },
    [getMCCRates.pending]: (state) => {
      state.isFetchingMCCRates = true;
      state.mccRates = null;
    },
    [getMCCRates.rejected]: (state) => {
      state.isFetchingMCCRates = false;
      state.mccRates = null;
    },
    [getMCCRates.fulfilled]: (state, { payload }) => {
      state.isFetchingMCCRates = false;
      state.mccRates = payload;
    },
    [updateMCCRates.pending]: (state) => {
      state.isUpdatingMCCRates = true;
    },
    [updateMCCRates.rejected]: (state) => {
      state.isUpdatingMCCRates = false;
    },
    [updateMCCRates.fulfilled]: (state) => {
      state.isUpdatingMCCRates = false;
    },
  },
});

export const selectIsFetchingMCCCurrencies = (state) =>
  state.conversionRates.mcc.isFetchingMCCCurrencies;

export const selectMCCCurrencies = (state) =>
  state.conversionRates.mcc.mccCurrencies;

export const selectIsFetchingMCCRates = (state) =>
  state.conversionRates.mcc.isFetchingMCCRates;

export const selectMCCRates = (state) => state.conversionRates.mcc.mccRates;

export const selectIsUpdatingMCCRates = (state) =>
  state.conversionRates.mcc.isUpdatingMCCRates;

export const mccActions = mccSlice.actions;

export default mccSlice.reducer;
